document.addEventListener('DOMContentLoaded', () => {
    const badges = document.querySelectorAll('.agency__badge[data-badge-url]');
    badges.forEach(badge => {
        const url = badge.getAttribute('data-badge-url');
        if (url) {
            badge.style.backgroundImage = `url(${url})`;
        }
    });
});
